import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import { closeModal } from "../../actions/modalAction";
import { withRouter } from "react-router-dom";

import { Form, Button } from "semantic-ui-react";
import TextArea from "../form/TextArea";
import TextInput from "../form/TextInput";
import SelectInput from "../form/SelectInput";
import {
  //composeValidators,
  combineValidators,
  isRequired,
} from "revalidate";
import CloseButton from "../common/CloseButton";

//
const validate = combineValidators({
  rating: isRequired("Rating"),
  review: isRequired("Review"),
  reviewType: isRequired("Review Type"),
});

//#######
const ratingO = [
  { key: "1", value: 1, text: "1 Star" },
  { key: "2", value: 2, text: "2 Star" },
  { key: "3", value: 3, text: "3 Star" },
  { key: "4", value: 4, text: "4 Star" },
  { key: "5", value: 5, text: "5 Star" },
];
const rating = () => {
  return ratingO.map((value) => ({
    key: value.key,
    text: value.text ? value.text : " N/A",
    value: value.value,
    style: { fontSize: "18px" },
  }));
};
// ***
const typeOfReviewO = [
  { key: "1", value:'Text', text: 'Text' },
  { key: "2", value: 'Video', text: 'Video' }
];
const typeOfReview = () => {
  return typeOfReviewO.map((value) => ({
    key: value.key,
    text: value.text ? value.text : " N/A",
    value: value.value,
    style: { fontSize: "18px" },
  }));
};
//

class ReviewCreate extends Component {
  onSubmit = async (values) => {
    //************
    try {
      const res = await axios.post(`/api/ReviewCreate`, values);

      if (res.data.msg === "success") {
        toastr.success("Review Created Successfully");
        this.props.handleCreateModalCloseSubmit();
      }
    } catch (error) {
      if (error && error.response && error.response.status == 401) {
        this.props.openModal("LoginModal");
        toastr.error(`${JSON.stringify(error.response.data)}`);
      } else if (error) {
        console.log("error_create_review", error);
        toastr.error(
          "Oops",
          "Something went wrong.Please Try Again_CreateReview"
        );
      }
    }
    //**********
  };
  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;
    const {
      reviewType
    } =
      this.props.state.form &&
      this.props.state.form.ReviewCreate !== undefined &&
      this.props.state.form.ReviewCreate.values !== undefined &&
      this.props.state.form.ReviewCreate.values;
    //*********************************
    return (
      <div className="marginBottom min-max-width">
        {this.props.btn && <CloseButton closeBtn={this.props.closeModal} />}
        <div style={{ margin: "auto" }}>
          {/**/}

          <div
            style={{
              textAlign: "center",
              fontSize: "1.5rem",
              fontWeight: "bold",
              padding: "15px",
              color: "dodgerblue",
            }}
          >
            {/*  */}
            Write Review
            {/*  */}
          </div>

          {/**/}
          <div className="">
            <div className=" label" style={{ textAlign: "left" }}>
              <Form
                style={{ padding: 20 }}
                onSubmit={handleSubmit(this.onSubmit)}
              >
                <Button
                  color="olive"
                  type="submit"
                  disabled={pristine || submitting}
                >
                  Submit
                </Button>
                <Button
                  color="orange"
                  type="button"
                  disabled={pristine || submitting}
                  onClick={reset}
                >
                  Clear Values
                </Button>

                <br />
                <div>
                  <span className="color-mandatory">* </span>Mandatory Fields
                </div>

                {this.props.userA !== null &&
                    (this.props.userA.userType === 'admin' || this.props.userA.userType === 'manager_dwk' || this.props.userA.userType === 'manager_ggn') && 
                  (
                    <>
                      <label>Name</label>
                      <Field
                        name="name"
                        type="text"
                        component={TextInput}
                        placeholder="Name"
                      />
                    </>
                  )}

                { this.props.userA !== null &&
                    (this.props.userA.userType === 'admin' || this.props.userA.userType === 'manager_dwk' || this.props.userA.userType === 'manager_ggn') &&
                   (
                    <>
                      <label>Review Type</label>
                <span className="color-mandatory"> * </span>
                <Field
                  name="reviewType"
                  placeholder="Review Type"
                  type="text"
                  options={typeOfReview()}
                  //search={true}
                  component={SelectInput}
                />
                    </>
                  )}
                <label>Write Review</label>
                <span className="color-mandatory"> * </span>
                <Field
                  name="review"
                  type="text"
                  component={TextArea}
                  rows={10}
                  placeholder="Review"
                />
                <label>Rating</label>
                <span className="color-mandatory"> * </span>
                <Field
                  name="rating"
                  placeholder="Rating"
                  type="text"
                  options={rating()}
                  //search={true}
                  component={SelectInput}
                />
                {reviewType === 'Video' && this.props.userA !== null &&
                    (this.props.userA.userType === 'admin' || this.props.userA.userType === 'manager_dwk' || this.props.userA.userType === 'manager_ggn') &&
                   (
                    <>
                      <label>Video URL</label>
                      <Field
                        name="videoPath"
                        type="text"
                        component={TextInput}
                        placeholder="Video URL"
                      />
                    </>
                  )}
               
                <br />

                <Button
                  color="olive"
                  type="submit"
                  disabled={pristine || submitting}
                >
                  Submit
                </Button>
                <Button
                  color="orange"
                  type="button"
                  disabled={pristine || submitting}
                  onClick={reset}
                >
                  Clear Values
                </Button>

                <br />
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    state,
    userA: state.auth.userA,
  };
};

export default connect(
  mapStateToProps,

  { closeModal }
)(
  reduxForm({
    form: "ReviewCreate", // a unique identifier for this form
    validate,
  })(withRouter(ReviewCreate))
);
